<template>
  <v-container fluid>
    <div class="d-flex justify-space-between align-center py-2">
      <span class="font-weight-medium py-2 flex-shrink-0">ส่งประกาศ</span>
      <v-scroll-x-transition>
        <div style="display: flex" v-show="!announcementFormShow">
          <v-text-field
            v-model="search"
            label="ค้นหา"
            prepend-inner-icon="mdi-magnify"
            clearable
            flat
            solo
            dense
            hide-details
            style="width: 200px; padding: 0 5px"
          ></v-text-field>
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::announcement:create')"
            style="margin-top: 1px"
            color="primary"
            @click="handleAddAnnouncementForm"
          >
            <v-icon small left>mdi-plus</v-icon>เพิ่มประกาศ
          </v-btn>
        </div>
      </v-scroll-x-transition>
    </div>
    <v-data-table
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :loading="loading"
      loading-text="Loading... Please wait"
      :search="search"
      :headers="headers"
      :items="announcements"
      :items-per-page="10"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [10, 25, 50, 100],
        itemsPerPageText: 'Rows per page:',
      }"
      :item-class="classRowSelected"
      @click:row="handleRowSelected"
    >
      <template v-slot:item.created_at="{ item }">
        {{ item.created_at | dateTimeFormat }}
      </template>
      <template v-slot:item.sent_datetime="{ item }">
        <div v-if="item.sent_datetime">
          {{ item.sent_datetime | dateTimeFormat }}
        </div>
        <div v-else>-</div>
      </template>
      <template v-slot:item.expired_datetime="{ item }">
        <div v-if="item.expired_datetime">
          {{ item.expired_datetime | dateTimeFormat }}
        </div>
        <div v-else>-</div>
      </template>
    </v-data-table>
    <AnnouncementForm
      :formShow="announcementFormShow"
      :formAction="announcementFormAction"
      :announcement="announcement"
      :announcementInit="announcementInit"
      @isAnnouncementDataChange="handleAnnouncementFormDataChange"
      @formActionCompleted="handleAnnouncementFormActionCompleted"
      @onReset="handleAnnouncementFormReset"
      @onClickSendAnnouncement="announcementSendFormShow = true"
    />
    <AnnouncementSendForm
      :formShow="announcementSendFormShow"
      :announcement="announcement"
      @isAnnouncementSendFormDataChange="handleAnnouncementSendFormDataChange"
      @onClickBlack="announcementSendFormShow = false"
      @handleSendAnnouncementCompleted="handleSendAnnouncementCompleted"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <v-overlay
      :value="
        (announcementFormShow && announcementFormAction === 'add') ||
        (announcementSendFormShow && announcementFormAction === 'edit')
      "
      z-index="0"
    ></v-overlay>
    <ForbiddenDialog
      :dialog="dialogForbidden"
      @onCloseDialog="dialogForbidden = false"
    />
  </v-container>
</template>

<script>
import moment from 'moment'

import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import AnnouncementForm from '@/views/announcement/AnnouncementForm.vue'
import AnnouncementSendForm from '@/views/announcement/AnnouncementSendForm.vue'

export default {
  components: {
    AnnouncementForm,
    AnnouncementSendForm,
    ConfirmDialog,
  },
  data() {
    return {
      dialogForbidden: false,
      sortBy: ['title'],
      sortDesc: [false],
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      loading: true,
      search: '',
      headers: [
        {
          text: 'หัวข้อ',
          align: 'start',
          value: 'title',
        },
        { text: 'สร้างเมื่อ', width: '160', value: 'created_at' },
        { text: 'ส่งเมื่อ', width: '160', value: 'sent_datetime' },
        { text: 'ส่งถึง (คน)', width: '120', value: 'stat.send' },
        { text: 'อ่านแล้ว (คน)', width: '120', value: 'stat.read' },
        { text: 'หมดอายุเมื่อ', width: '160', value: 'expired_datetime' },
      ],
      announcementFormShow: false,
      announcementSendFormShow: false,
      announcementFormAction: '',
      announcement: {},
      announcementInit: {},
      isAnnouncementDataChange: false,
      isAnnouncementSendFormDataChange: false,
      timeout: null,
    }
  },
  filters: {
    dateTimeFormat: function (value) {
      return moment(value).format('DD/MM/YYYY HH:mm')
    },
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    announcements() {
      return this.$store.state.announcement.announcements
    },
  },
  created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'ส่งประกาศ',
        disabled: true,
      },
    ])

    this.loadData()
  },
  methods: {
    ...mapActions({
      fetchAnnouncements: 'announcement/fetchAnnouncements',
    }),
    handleAnnouncementSendFormDataChange(value) {
      this.isAnnouncementSendFormDataChange = value
    },
    handleSendAnnouncementCompleted() {
      this.announcementSendFormShow = false
      this.announcement = {}
      this.announcementInit = {}
      this.announcementFormShow = false
      this.announcementFormAction = ''
    },
    classRowSelected(row) {
      if (this.announcement.announcement_uuid === row.announcement_uuid)
        return 'row-selected'
    },
    setDataRowSelected(row) {
      if (this.uiCtrl && !this.uiCtrl.isEnable('row:::announcement:get')) {
        this.dialogForbidden = true
        return
      }

      if (this.announcement.announcement_uuid === row.announcement_uuid) {
        this.announcementFormShow = false
        this.announcementFormAction = ''
        this.announcement = {}
        this.announcementInit = {}
      } else {
        this.announcementFormShow = true
        this.announcementFormAction = 'edit'
        this.announcement = {
          ...row,
          expired_datetime: row.expired_datetime
            ? new Date(row.expired_datetime)
            : null,
        }
        this.announcementInit = {
          ...row,
          expired_datetime: row.expired_datetime
            ? new Date(row.expired_datetime)
            : null,
        }
      }
    },
    handleRowSelected(row) {
      if (this.isAnnouncementDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
          item: {
            type: 'row',
            data: row,
          },
        }
        this.confirmDialogDataChange = true
      } else {
        this.setDataRowSelected(row)
      }
    },
    handleAddAnnouncementForm() {
      this.announcementFormShow = true
      this.announcementFormAction = 'add'
      this.announcement = {}
      this.announcementInit = {}
    },
    handleAnnouncementFormDataChange(value) {
      this.isAnnouncementDataChange = value
    },
    handleAnnouncementFormReset(formAction) {
      this.announcement = {}
      this.announcementInit = {}
      this.announcementFormShow = false
      this.announcementFormAction = ''
    },
    handleAnnouncementFormActionCompleted(formData) {
      if (formData?.formAction === 'add' && formData?.action === 'submitting') {
        this.announcement = { ...formData?.data }
        this.announcementInit = { ...formData?.data }
      } else {
        this.announcement = {}
        this.announcementInit = {}
        this.announcementFormShow = false
        this.announcementFormAction = ''
      }
    },
    loadData() {
      const { company_uuid } = this.$store.state.authentication.company

      const payload = {
        company_uuid,
        // params: { dpc: 'announcement-to-list-announcement' },
      }

      const announcements = this.fetchAnnouncements(payload)

      Promise.all([announcements])
        .then(() => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange(item) {
      if (item.type === 'row') {
        this.confirmDialogDataChange = false
        this.setDataRowSelected(item.data)
      } else {
        this.confirmDialogDataChange = false
        this.nextRoute(item.data)
      }
    },
    nextRoute(next) {
      this.announcementFormShow = false
      this.announcementSendFormShow = false

      this.timeout = setTimeout(() => {
        next()
      }, 200)
    },
  },
  beforeRouteLeave(to, from, next) {
    if (
      this.isAnnouncementDataChange ||
      this.isAnnouncementSendFormDataChange
    ) {
      this.confirmDialogDataChangeData = {
        title: 'ต้องการออกจากหน้านี้ใช่ไหม',
        text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการออกโดยที่ยังไม่บันทึกข้อมูล',
        value: '',
        item: {
          type: 'next',
          data: next,
        },
      }
      this.confirmDialogDataChange = true
    } else {
      this.nextRoute(next)
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  },
}
</script>
